import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function ScrollToTop() {
  const { pathname } = useLocation();
  //payload
  const payload = useSelector((state) => state.scroll);
  /* eslint-disable */
  useEffect(() => {
    payload.scrollToTopHandler();
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
